import React, { useState } from "react";

/**
 * SafeImage — wraps <img> with an onError fallback to a known-good
 * Biodeal Animal Health themed image (East African cattle / vet field photo),
 * so that no card or hero ever displays a broken image icon.
 *
 * Falls back twice:
 *   1) The provided `fallback` prop (if it differs from src)
 *   2) The built-in BAH-themed safe URL
 */

// East-African dairy cows in pasture at sunset — verified animal-health
// Pexels image used as ultimate fallback so a broken upstream image still
// renders on-brand veterinary content.
const BAH_SAFE_FALLBACK =
  "https://images.pexels.com/photos/422218/pexels-photo-422218.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400";

export default function SafeImage({
  src,
  alt = "",
  fallback,
  className = "",
  loading = "lazy",
  ...rest
}) {
  const [current, setCurrent] = useState(src);
  const [stage, setStage] = useState(0); // 0 = primary, 1 = secondary, 2 = safe

  const onError = () => {
    if (stage === 0 && fallback && fallback !== src) {
      setCurrent(fallback);
      setStage(1);
    } else if (stage < 2 && current !== BAH_SAFE_FALLBACK) {
      setCurrent(BAH_SAFE_FALLBACK);
      setStage(2);
    }
  };

  return (
    <img
      src={current}
      alt={alt}
      loading={loading}
      onError={onError}
      className={className}
      {...rest}
    />
  );
}
